import { createAction, handleActions, combineActions } from 'redux-actions';
import { fromJS, Map, List } from 'immutable';
import { createSelector } from 'reselect';
import { normalize, schema } from 'normalizr';

// Schemas
const testEntity = new schema.Entity('tests');

// Actions
export const fetchTests = createAction('TESTS_FETCH');
export const fetchTestsSuccess = createAction('TESTS_FETCH_SUCCESS');
export const fetchTestsFail = createAction('TESTS_FETCH_FAIL');

export const fetchTest = createAction('TEST_FETCH');
export const fetchTestSuccess = createAction('TEST_FETCH_SUCCESS');
export const fetchTestFail = createAction('TEST_FETCH_FAIL');

export const createTest = createAction('TEST_CREATE');
export const createTestSuccess = createAction('TEST_UPDATE_SUCCESS');
export const createTestFail = createAction('TEST_CREATE_FAIL');

export const updateTest = createAction('TEST_UPDATE');
export const updateTestSuccess = createAction('TEST_UPDATE_SUCCESS');
export const updateTestFail = createAction('TEST_UPDATE_FAIL');

export const deleteTest = createAction('TEST_DELETE');
export const deleteTestSuccess = createAction('TEST_DELETE_SUCCESS');
export const deleteTestFail = createAction('TEST_DELETE_FAIL');

export const actions = {
  fetchTests,
  fetchTestsSuccess,
  fetchTestsFail,
  fetchTest,
  fetchTestSuccess,
  fetchTestFail,
  createTest,
  createTestSuccess,
  createTestFail,
  updateTest,
  updateTestSuccess,
  updateTestFail,
  deleteTest,
  deleteTestSuccess,
  deleteTestFail,
};

const defaultState = fromJS({
  result: List([]),
  data: {},
  isFetching: true,
  error: {},
});

export default handleActions({
  [fetchTests]: (state) => {
    return state.merge({
      isFetching: true,
    })
  },

  [fetchTestsSuccess]: (state, action) => {
    const normalizedData = normalize(action.payload, [testEntity])
    return state.merge({
      result: normalizedData.result,
      data: normalizedData.entities.tests || {},
      isFetching: false
    })
  },

  [combineActions(
    fetchTestSuccess,
    createTestSuccess,
    updateTestSuccess,
  )]: (state, action) => {
    const normalizedData = normalize(action.payload, testEntity)
    return state.merge({
      result: [],
      data: normalizedData.entities.tests,
      isFetching: false
    })
  },

  [deleteTestSuccess]: (state, action) => {
    const { id } = action.payload;
    const result = state.get('result');
    const data = state.get('data');

    return state.merge({
      result: result.delete(result.indexOf(id)),
      data: data.delete(id),
    });
  },

  [combineActions(
    fetchTestsFail,
    fetchTestFail,
    createTestFail,
    updateTestFail,
  )]: (state, action) => {
    return state.merge({
      error: action.payload,
      isFetching: false
    })
  }
}, defaultState);

// selectors
const resultSelector = state => state.test.data.get('result');
const testsSelector = state => state.test.data.get('data');
const isFetchingSelector = state => state.test.data.get('isFetching');
const paginationSelector = state => state.test.pagination;

export const getTests = createSelector(
  resultSelector,
  testsSelector,
  (result, tests) => result.map(id => tests.get(String(id))).toJS(),
);

export const getTest = (state, id) =>
  (testsSelector(state).get(String(id)) || new Map()).toJS();

export const isFetching = createSelector(
  isFetchingSelector,
  isFetching => isFetching
);

export const getTestsPagination = createSelector(
  paginationSelector,
  paginationData => paginationData.toJS(),
);



// WEBPACK FOOTER //
// ./src/store/testReducer.js